import { useState } from "react";
import { Menu, X } from "lucide-react";

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="flex justify-between items-center py-4 mb-16 relative">
      <div className="flex items-center">
        <a href="/">
          <img
            src="/logo.png"
            alt="Hotel Hero Logo"
            className="w-10 h-10 object-contain mr-3"
          />
        </a>

        <h1 className="text-2xl font-bold">
          Hotel<span className="text-orange-500">Hero</span>
        </h1>
      </div>

      <nav>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-blue-500"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        <ul
          className={`flex flex-col md:flex-row text-blue-500 md:space-x-8 absolute md:static top-16 right-0 bg-white md:bg-transparent w-full md:w-auto p-6 md:p-4 shadow md:shadow-none transition-all duration-300 ${
            isOpen ? "block" : "hidden md:flex"
          }`}
        >
          {[
            { href: "#features", label: "Features" },
            { href: "#gameplay", label: "Gameplay" },
            { href: "#video", label: "Video" },
            { href: "#testimonials", label: "Testimonials" },
            { href: "/about", label: "About" },
          ].map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="block py-2 md:py-0 hover:text-blue-400 transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
